import React from 'react';

const IconQuote = props => (
  <svg width={44} height={36} viewBox="0 0 44 36" {...props}>
    <path
      d="M41.984 27.795c0 4.522-3.694 8.205-8.228 8.205-5.878 0-9.07-4.688-9.07-10.382 0-7.869 5.542-18.586 17.466-25.618L44 2.68c-6.215 5.358-9.405 11.72-10.748 16.576 5.374.335 8.732 4.018 8.732 8.539zm-24.687 0c0 4.522-3.694 8.205-8.229 8.205C3.191 36 0 31.312 0 25.618 0 17.751 5.541 7.034 17.465 0l1.848 2.68C13.098 8.037 9.908 14.4 8.565 19.255c5.373.335 8.732 4.018 8.732 8.539z"
      fill="#CCC"
      fillRule="evenodd"
    />
  </svg>
);

export default IconQuote;
